export default "__VITE_ASSET__W$_DlL4F__"